import React, { useEffect } from 'react';

import Analytics from 'analytics-opencare';

import SingleSelect from 'pages/common/components/SingleSelect/SingleSelect';
import { OptionBlock, Subtitle, Title } from 'pages/common/styled-components';
import { getSpecialistData } from 'pages/funnel/specialtyFlow/funnelUtils';
import { useFunnelStorage } from 'pages/funnel/storage/Storage';
import { StepWrapper } from 'pages/funnel/styled-components';
import { generateStepAnalytics, STEP_KEY } from 'pages/funnel/utils';
import { useAnalyticsService } from 'services/AnalyticsService';

import { FunnelStepPropTypes } from '../../common/types';

const analytics = new Analytics();

const ConfirmNoReferral = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();
  const analyticsService = useAnalyticsService();

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_specialist-confirm-no-referral',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const { specialistTitleWithIndefiniteArticle } = getSpecialistData(storage);

  const options = [
    {
      id: 'yes',
      title: "Yes, I'd like a general dentist",
      value: true,
    },
    {
      id: 'no',
      title: `No, I want to see ${specialistTitleWithIndefiniteArticle}`,
      value: false,
    },
  ];

  const submitAnswer = (selectedOption, index) => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_specialist-referral',
      name: 'wizard',
      section: 'confirm-no-referral',
      ...generateStepAnalytics(index, storage, {
        response: selectedOption.id,
      }),
    });

    // We need to keep the answer from the previous step
    const savedData = storage.get(STEP_KEY.SPECIALIST_REFERRAL) || {};

    storage.save(
      STEP_KEY.SPECIALIST_REFERRAL,
      {
        ...savedData,
        seeGeneralDentist: selectedOption.value,
      },
      true,
    );

    // Note - we always stay in this branch even if the user wants to see a general dentist
    // since we surface general dentists in the specialist search results anyway
    moveToNextStep();
  };

  return (
    <div>
      <Title id="title">Would you like to find a general dentist first?</Title>
      <Subtitle>
        A general dentist can assess your needs and help determine if a
        specialist is necessary.
      </Subtitle>
      <StepWrapper>
        <form>
          <OptionBlock row={2}>
            {options.map((option, i) => (
              <SingleSelect
                name={option.id}
                key={option.id}
                id={option.id}
                title={option.title}
                describedBy="title"
                onChange={() => submitAnswer(option, i)}
              />
            ))}
          </OptionBlock>
        </form>
      </StepWrapper>
    </div>
  );
};

ConfirmNoReferral.propTypes = FunnelStepPropTypes;

export { ConfirmNoReferral };
